/** @format */

import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import compose from 'recompose/compose';
import withStyles from '@material-ui/core/styles/withStyles';
import { FormGeneralHelper } from 'helpers/FormGeneral';
import { history } from 'core/history';

import TariffSelectComponent from 'components/Adescom/TariffSelectApi';
import GeoLoactionSelectComponent from 'components/Adescom/GeoLocationStateSelectApi';

import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Heading/CardHeaderExt';
import CustomButtom from 'components/CustomButtons/ButtonExt';
import CancelTextButton from 'components/Buttons/CancelTextButtons';

import Person from '@material-ui/icons/Person';
import AccountBalance from '@material-ui/icons/AccountBalance';

import adescomStyle from 'assets/jss/adescom/adescomStyle';
import InputFormRest from 'components/Form/InputFormRest';
import CheckBoxFormRest from 'components/Form/CheckBoxFormRest';

import SnackBarMessage from 'helpers/SnackBarMessage';
import { clientsActions, clientsConstants } from 'modules/clients/actions';

import SimCardList from 'views/SimCard/SimCardList';
import { ClientEntityErrorState } from 'modules/clients/Entity';

import I18n from 'components/Translate/I18n';
import CustomTextButtom from 'components/Buttons/CustomTextButton';
import ClientAddressesDialog from 'views/Clients/adresses/ClientAddressesDialog';
import { clientsReducers } from 'modules/clients/reducers';
import { StoreHelper } from 'helpers/StoreHelper';

class ClientsEdit extends React.Component {
    constructor(props) {
        super(props);

        StoreHelper.requiresStore(this, 'clientsReducers');

        this.state = {
            item: null,
            entityStatus: ClientEntityErrorState,
            entity: null,
            openClientAddresses: false,

            uri: props.chamskieuri || '/' + props.match.params.id,
            snackBarStatus: false,
            snackBarMessage: '',
            snackBarVariant: 'success',
            editSuccess: false,
        };

        this.initial();
    }

    initial = () => {
        const { dispatch } = this.props;
        dispatch(clientsActions.get(FormGeneralHelper.getByUri(this.state.uri), clientsConstants.CLIENTS_ITEM));
    };

    returnClientList = () => {
        history.push(FormGeneralHelper.getRouteUrl('/clients-list'));
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (nextProps.item && this.state.item === null) {
            this.setState({ item: nextProps.item, entity: nextProps.item });
            return false;
        }
        return true;
    }

    change = (e, stateName, type, require, maxValue, minValue) => {
        FormGeneralHelper.validateForms(this, e, stateName, type, require, maxValue, minValue);
    };

    submitCallBackDispatch = () => {
        const { dispatch } = this.props;
        dispatch(clientsActions.put(FormGeneralHelper.getByUri(this.state.uri), this.state.entity, clientsConstants.CLIENTS_EDIT));
    };

    handleSubmit = (e) => {
        FormGeneralHelper.handleSubmit(this, e, this.submitCallBackDispatch, true);
    };

    closeSnackbarCallback = () => {
        this.setState({ snackBarStatus: false, snackBarMessage: '' });
    };

    selectFunc = (e, stateName, require) => {
        const value = e.target.value;
        if (FormGeneralHelper.verifyNumber(value) && value > 0) {
            this.setState((prevState) => ({
                item: {
                    ...prevState.item,
                    [stateName]: value,
                },
                entityStatus: {
                    ...prevState.entityStatus,
                    [stateName]: null,
                },
            }));
            return;
        }
        this.setState((prevState) => ({
            entityStatus: {
                ...prevState.entityStatus,
                [stateName]: FormGeneralHelper.ERROR,
            },
        }));
    };

    openClientAddressesDialog = () => {
        this.setState((prevState) => ({
            openClientAddresses: true,
        }));
    };

    closeClientAddressesDialog = () => {
        this.setState((prevState) => ({
            openClientAddresses: false,
        }));
    };

    render() {
        const { classes } = this.props;
        const { entity, entityStatus } = this.state;
        if (entity) {
            return (
                <div>
                    <form onSubmit={this.handleSubmit} key="client_form">
                        <GridContainer>
                            {entity && entity.id && (
                                <ClientAddressesDialog
                                    classes={classes}
                                    callBackClose={this.closeClientAddressesDialog}
                                    open={this.state.openClientAddresses}
                                    clientId={entity.id}
                                />
                            )}
                            <GridItem xs={12} sm={12} md={8}>
                                <Card>
                                    <CardHeader icon={<Person />} trans="general:common.client" />
                                    <CardBody>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <InputFormRest
                                                    classes={classes}
                                                    callback={this.change}
                                                    stateName="firstname"
                                                    stateObjectState={entityStatus.firstname}
                                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                                    displayFieldName="clients:c.firstname"
                                                    vMax={256}
                                                    vMin={-1}
                                                    required={false}
                                                    value={entity.firstname}
                                                />
                                                <InputFormRest
                                                    classes={classes}
                                                    callback={this.change}
                                                    stateName="mainname"
                                                    stateObjectState={entityStatus.mainname}
                                                    typeCallback={FormGeneralHelper.TYPE_TEXT}
                                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                                    displayFieldName="clients:c.name"
                                                    required={true}
                                                    vMax={256}
                                                    vMin={-1}
                                                    value={entity.mainname}
                                                />
                                                <InputFormRest
                                                    classes={classes}
                                                    callback={this.change}
                                                    stateName="email"
                                                    stateObjectState={entityStatus.email}
                                                    typeCallback={FormGeneralHelper.TYPE_EMAIL}
                                                    typeField={FormGeneralHelper.TYPE_TEXT}
                                                    displayFieldName="Email"
                                                    required={false}
                                                    vMax={-1}
                                                    vMin={-1}
                                                    value={entity.email}
                                                />
                                                <CheckBoxFormRest checked={entity.isPrivateClient} label={'clients:c.is_private_client'} />
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <GridContainer>
                                                    <GridItem xs={12} sm={12} md={6}>
                                                        <InputFormRest
                                                            classes={classes}
                                                            callback={this.change}
                                                            stateName="street"
                                                            stateObjectState={entityStatus.street}
                                                            typeCallback={FormGeneralHelper.TYPE_TEXT}
                                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                                            displayFieldName="clients:c.street"
                                                            required={false}
                                                            vMax={256}
                                                            vMin={-1}
                                                            value={entity.street}
                                                        />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={6}>
                                                        <InputFormRest
                                                            classes={classes}
                                                            callback={this.change}
                                                            stateName="contactphone"
                                                            stateObjectState={entityStatus.contactphone}
                                                            typeCallback={FormGeneralHelper.TYPE_TEXT}
                                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                                            displayFieldName="clients:c.contactphone"
                                                            required={false}
                                                            vMax={256}
                                                            vMin={-1}
                                                            value={entity.contactphone}
                                                        />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={6}>
                                                        <InputFormRest
                                                            classes={classes}
                                                            callback={this.change}
                                                            stateName="house"
                                                            stateObjectState={entityStatus.house}
                                                            typeCallback={FormGeneralHelper.TYPE_TEXT}
                                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                                            displayFieldName="clients:c.house"
                                                            required={false}
                                                            vMax={32}
                                                            vMin={-1}
                                                            value={entity.house}
                                                        />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={6}>
                                                        <InputFormRest
                                                            classes={classes}
                                                            callback={this.change}
                                                            stateName="apartment"
                                                            stateObjectState={entityStatus.apartment}
                                                            typeCallback={FormGeneralHelper.TYPE_TEXT}
                                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                                            displayFieldName="clients:c.apartment"
                                                            required={false}
                                                            vMax={32}
                                                            vMin={-1}
                                                            value={entity.apartment}
                                                        />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={6}>
                                                        <InputFormRest
                                                            classes={classes}
                                                            callback={this.change}
                                                            stateName="zip"
                                                            stateObjectState={entityStatus.zip}
                                                            typeCallback={FormGeneralHelper.TYPE_ZIP}
                                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                                            displayFieldName="clients:c.zip_code_00_000"
                                                            required={true}
                                                            vMax={64}
                                                            vMin={5}
                                                            value={entity.zip}
                                                        />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={6}>
                                                        <InputFormRest
                                                            classes={classes}
                                                            callback={this.change}
                                                            stateName="city"
                                                            stateObjectState={entityStatus.city}
                                                            typeCallback={FormGeneralHelper.TYPE_TEXT}
                                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                                            displayFieldName="clients:c.city"
                                                            required={false}
                                                            vMax={256}
                                                            vMin={-1}
                                                            value={entity.city}
                                                        />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={6}>
                                                        <GeoLoactionSelectComponent
                                                            callbackSelect={this.selectFunc}
                                                            stateIdState={entityStatus.altStateId}
                                                            stateIdSelected={entity.altStateId}
                                                            stateName="altStateId"
                                                        />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={6}>
                                                        <InputFormRest
                                                            classes={classes}
                                                            callback={this.change}
                                                            stateName="country"
                                                            stateObjectState={entityStatus.country}
                                                            typeCallback={FormGeneralHelper.TYPE_TEXT}
                                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                                            displayFieldName="clients:c.country"
                                                            required={false}
                                                            vMax={64}
                                                            vMin={-1}
                                                            value={entity.country}
                                                        />
                                                    </GridItem>
                                                </GridContainer>
                                            </GridItem>
                                        </GridContainer>
                                    </CardBody>
                                </Card>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                                <Card>
                                    <CardHeader icon={<AccountBalance />} trans="general:common.billing" />
                                    <CardBody>
                                        <TariffSelectComponent
                                            callbackSelect={this.selectFunc}
                                            tariffIdState={entityStatus.tariffId}
                                            tariffIdSelected={entity.tariffId}
                                            stateName="tariffId"
                                        />
                                        <InputFormRest
                                            classes={classes}
                                            callback={this.change}
                                            stateName="nip"
                                            stateObjectState={entityStatus.nip}
                                            typeCallback={FormGeneralHelper.TYPE_NIP}
                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                            displayFieldName="NIP"
                                            required={false}
                                            vMax={10}
                                            value={entity.nip}
                                        />
                                        <InputFormRest
                                            classes={classes}
                                            callback={this.change}
                                            stateName="pesel"
                                            stateObjectState={entityStatus.pesel}
                                            typeCallback={FormGeneralHelper.TYPE_PESEL}
                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                            displayFieldName="clients:c.pesel"
                                            required={false}
                                            vMax={11}
                                            value={entity.pesel}
                                        />
                                        <InputFormRest
                                            classes={classes}
                                            callback={this.change}
                                            stateName="regon"
                                            stateObjectState={entityStatus.regon}
                                            typeCallback={FormGeneralHelper.TYPE_REGON}
                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                            displayFieldName="REGON"
                                            required={false}
                                            vMin={8}
                                            vMax={15}
                                            value={entity.regon}
                                        />
                                        <InputFormRest
                                            classes={classes}
                                            callback={this.change}
                                            stateName="businessName"
                                            stateObjectState={entityStatus.businessName}
                                            typeCallback={FormGeneralHelper.TYPE_TEXT}
                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                            displayFieldName="clients:c.business_name"
                                            required={false}
                                            vMin={0}
                                            vMax={255}
                                            value={entity.businessName}
                                        />
                                        <InputFormRest
                                            classes={classes}
                                            callback={this.change}
                                            stateName="bankaccount"
                                            disabled={true}
                                            stateObjectState={entityStatus.bankaccount}
                                            typeCallback={FormGeneralHelper.TYPE_NUMBER}
                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                            displayFieldName="clients:c.bank_account"
                                            required={false}
                                            vMax={34}
                                            vMin={-1}
                                            value={entity.bankaccount}
                                        />
                                        <InputFormRest
                                            classes={classes}
                                            callback={this.change}
                                            stateName="user1"
                                            stateObjectState={entityStatus.user1}
                                            typeCallback={FormGeneralHelper.TYPE_TEXT}
                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                            displayFieldName="clients:c.user_field_1"
                                            required={false}
                                            vMax={-1}
                                            vMin={-1}
                                            value={entity.user1}
                                        />
                                        <InputFormRest
                                            classes={classes}
                                            callback={this.change}
                                            stateName="user2"
                                            stateObjectState={entityStatus.user2}
                                            typeCallback={FormGeneralHelper.TYPE_TEXT}
                                            typeField={FormGeneralHelper.TYPE_TEXT}
                                            displayFieldName="clients:c.user_field_2"
                                            required={false}
                                            vMax={-1}
                                            vMin={-1}
                                            value={entity.user1}
                                        />
                                    </CardBody>
                                </Card>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                                <CustomButtom type="submit">
                                    <I18n trans="clients:c.save_client" />
                                </CustomButtom>
                                <CancelTextButton callback={this.returnClientList} />
                                <CustomTextButtom label="clients:a.client_addresses" callback={this.openClientAddressesDialog} />
                            </GridItem>
                        </GridContainer>
                        <SnackBarMessage
                            closeCallback={this.closeSnackbarCallback}
                            open={this.state.snackBarStatus}
                            text={this.state.snackBarMessage}
                            variant={this.state.snackBarVariant}
                        />
                    </form>
                    {!this.props.partial && <SimCardList key="sim_card_form" searchBarSwitch={() => {}} clientId={entity.id} uri={this.state.uri} />}
                </div>
            );
        } else {
            return <div>Loading....</div>;
        }
    }
}

ClientsEdit.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => {
    const { clientsReducers } = state;
    if (clientsReducers === undefined) {
        return { ...state };
    }
    let item = null;
    if (clientsReducers.clientItem) {
        item = clientsReducers.clientItem;
    }
    return {
        editSuccess: clientsReducers.success,
        item: item,
    };
};

const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));

const Enhance = enhance(ClientsEdit);

export default Enhance;
